export function removeUnnecessarySpaces(value: string) {
  return value
    .trim()
    .replace(/  +/g, " ")
    .replace(/ +(?= )/g, "")
    .trim();
}
